import {LinkGroup} from 'shared/pretty-easy-navigation/models';
import {ContactLink, LegalMentionsLink} from '../links';
import {NavigationContext} from '../navigation.context';
import {SiteMapLink} from "../links/site-map.link";

export const GuestFooterGroup = (context: NavigationContext): LinkGroup => ({
    type: 'linkGroup',
    links: [
        ContactLink(context),
        LegalMentionsLink(context),
        SiteMapLink(context, null)
    ]
});